import angular from 'angular';
import uiRouter from 'angular-ui-router';
import projectManagerComponent from './projectManager.component';

let projectManagerModule = angular.module('projectManager', [
  uiRouter
]).component('projectManager', projectManagerComponent)
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider
      .state('apps.projectManager', {
        url: '/project-manager',
        component: 'projectManager',
        resolve: {
          $title: () => 'Progetto Manager'
        }
      });
  })
  .name;

export default projectManagerModule;



// WEBPACK FOOTER //
// ./client/app/components/apps/projectManager/projectManager.js